import { format } from "date-fns-tz"

const timezoneName = (date, timeZone) => {
  if (!date) {
    return
  }

  const pattern = new RegExp(
    /\s(Standard|Summer|Universal|Daylight)?\sTime/,
    "i"
  )
  return format(Date.parse(date), "zzzz", { timeZone }).replace(pattern, "")
}

/**
 * Normalize a Date or parseable date string to an ISO 8601 string.
 * Returns null for null/undefined/empty/unparseable input.
 *
 * @param {Date | String | null | undefined} value
 * @return {String | null}
 */
const toIsoString = value => {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  return isNaN(date.getTime()) ? null : date.toISOString()
}

export { timezoneName, toIsoString }
